export const resources = {
  BaseUrl: "https://websitebackend.ntar.biz/",
};


// export const resources={
//   BaseUrl:"http://192.168.0.235:3000/",
//   }